import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  FlatList,
  Modal,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../utils/Colours";

import LocationIcon from "../icons/LocationIcon";
import APullScreen from "../screens/aPullScreen/APullScreen";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const PartyHeatComp = ({
  pullSearchResults,
  useCaption,
  tableToUseID,
  contributors,
  usePull,
  useContributionAmount,
  tableDataToUse,

  showTheDoingsAmount,
  setShowTheDoingsAmount,
  showA_PartyHeatScreen,
  setShowA_PartyHeatScreen,
  showPartyHeatComp,
  setShowPartyHeatComp,

  successMessage,
  setSuccessMessage,

  hideAllPayScreens,
}) => {
  const [show_aPullScreen, setShow_aPullScreen] = useState(false);
  const [selectedPullData, setSelectedPullData] = useState({});
  // const [selectedSearchResultID, setSelectedSearchResultID] = useState('')

  const handleOpenPullScreens = (resultID) => {
    //console.log('resultID', resultID)

    // Find the pull data in pullSearchResults based on the resultID
    const selectedPull = pullSearchResults.find((pull) => pull._id === resultID);

    if (selectedPull) {
      //console.log('Selected Pull Data:', selectedPull);

      setSelectedPullData(selectedPull);
      setShowA_PartyHeatScreen(true);
    } else {
      // console.error('No matching pull found for resultID:', resultID)
    }
  };

  return (
    <View style={styles.bodyContainer}>
      <Text style={styles.partiesTxt}>Parties, Shows & Experiences</Text>

      <FlatList
        data={pullSearchResults}
        scrollEnabled={false}
        keyExtractor={(item) => item._id}
        renderItem={({ item: pullSearch }) => (
          <>
            <TouchableOpacity
              style={styles.tablesListContainer2}
              onPress={() => {
                handleOpenPullScreens(pullSearch._id);
              }}
            >
              <View style={styles.tableListTitlesContain}>
                <View style={{ display: "flex", gap: 4 }}>
                  <View style={styles.locationPartyHeat}>
                    <LocationIcon
                      color={Colours.PRIMARY}
                      height={dynamicSize(15)}
                      width={dynamicSize(15)}
                    />
                    <Text style={styles.searchLocationTxt}>
                      {pullSearch?.location.toUpperCase()}
                    </Text>
                  </View>
                  <Text style={styles.pullCaptionTxt}>{pullSearch?.pullCaption}</Text>
                  <View style={styles.tableValueContainer}>
                    <Text style={styles.joinedTxt}>500 JOINED</Text>
                  </View>
                </View>
                <Image source={{ uri: pullSearch?.pictures }} style={styles.partyImgSmall} />
              </View>
            </TouchableOpacity>
            <View
              style={{
                height: 1,
                backgroundColor: Colours.LIGHTGRAY,
                marginVertical: 5,
                marginBottom: 10,
              }}
            />
          </>
        )}
      />
      <Modal visible={showA_PartyHeatScreen} animationType="fade">
        {/* <APullScreen
          pullsData={pullSearchResults}
          setShowAPullScreen={setShow_aPullScreen}

        /> */}
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    margin: dynamicSpacing(15),
    marginTop: 0,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  partiesTxt: {
    paddingBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(16),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Bold",
  },
  searchLocationTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Bold",
  },
  pullCaptionTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
    width: dynamicSpacing(200),
  },
  joinedTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  tableValueContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSpacing(130),
  },
  tablesListContainer2: {
    paddingBottom: dynamicSpacing(10),
    gap: dynamicSpacing(2),
  },
  tableListTitlesContain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: dynamicSpacing(2),
  },
  partyImgSmall: {
    width: dynamicSpacing(70),
    height: dynamicSpacing(60),
    borderRadius: dynamicSize(15),
  },
  locationPartyHeat: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
});

export default PartyHeatComp;
